import getJobStatus from 'utils/getJobStatusColor'
import { TextPill } from './TextPill'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

// DS2026 50/700 palette mapped to JobStatus IDs from getJobStatusColor.
// Submitted/Processing/Internal Review → neutral; Started → blue; Pending
// Approval → amber; Accepted → green; Rejected/Cancelled → red.
const DS2026_STATUS_CLASS: Record<number, string> = {
  0: 'bg-neutral-100 text-neutral-700',
  5: 'bg-neutral-100 text-neutral-700',
  15: 'bg-neutral-100 text-neutral-700',
  10: 'bg-blue-50 text-blue-700',
  20: 'bg-amber-50 text-amber-700',
  30: 'bg-green-50 text-green-700',
  40: 'bg-red-50 text-red-700',
  50: 'bg-red-50 text-red-700',
}

export function JobStatusPill({
  statusValue,
  statusLabel,
}: {
  statusValue: number
  statusLabel: string
}) {
  const variant = useTableLinkVariant()
  if (variant === 'plain') {
    const className =
      DS2026_STATUS_CLASS[statusValue] ?? 'bg-neutral-100 text-neutral-700'
    return (
      <span
        className={`inline-flex items-center rounded-2xl px-2.5 py-0.5 text-sm font-medium leading-5 ${className}`}
        style={{ letterSpacing: '-0.2px' }}
      >
        {statusLabel}
      </span>
    )
  }

  const colors = getJobStatus(statusValue)
  return (
    <TextPill
      style={{
        marginBottom: 2,
      }}
      textColor={colors[1]}
      backgroundColor={colors[0]}
    >
      {statusLabel}
    </TextPill>
  )
}
